// extracted by mini-css-extract-plugin
export default {"test":"styles_test__0fWVK","sectionTitle":"styles_sectionTitle__CAzlB"};